module.exports = __webpack_public_path__ + "static/media/5.9075d4d9.png";